import React, { useState } from "react";
import { useModal } from "react-modal-hook";
import { useHistory } from "react-router";
import { buildLink } from "common/routing";
import {
  ParcelImportConfiguration,
  ParcelImportTaskType,
} from "../../../../../generated/graphql";
import {
  ButtonSection,
  Container,
  ContentSection,
  FormSection,
  HeaderSection,
  PrimaryButtons,
} from "../../../../Common/__styles__/Modal";
import { Button } from "../../../../Common/Buttons/Button";
import Modal from "../../../../Common/Modal";

export const useConfigurationOverridesModal = ({
  parcelImportConfiguration,
}: {
  parcelImportConfiguration?: Maybe<ParcelImportConfiguration>;
}) => {
  const history = useHistory();

  const [importTaskTypeArg, setImportTaskTypeArg] =
    useState<Maybe<ParcelImportTaskType>>(null);

  const [showConfigOverridesModal, hideConfigOverridesModal] = useModal(
    () => (
      <Modal onRequestClose={hideConfigOverridesModal}>
        <ConfigurationOverridesModal
          name={parcelImportConfiguration?.name ?? ""}
          importTaskType={importTaskTypeArg!}
          onCancel={hideConfigOverridesModal}
        />
      </Modal>
    ),
    [importTaskTypeArg],
  );

  const conditionallyShowModal = (importTaskType: ParcelImportTaskType) => {
    if (!parcelImportConfiguration) {
      history.push(
        buildLink("parcelImportConfigCreate", {
          importTaskType,
        }),
      );
      return;
    }

    setImportTaskTypeArg(importTaskType);
    showConfigOverridesModal();
  };

  return [conditionallyShowModal, hideConfigOverridesModal] as const;
};

const ConfigurationOverridesModal = ({
  name,
  importTaskType,
  onCancel,
}: {
  name: string;
  importTaskType: ParcelImportTaskType;
  onCancel: () => void;
}) => {
  const history = useHistory();

  return (
    <Container>
      <HeaderSection>
        <h1>Update parcel data source</h1>
      </HeaderSection>
      <FormSection>
        <ContentSection>
          <p>
            Your account already has a parcel data source setup. Are you sure
            you want to override <b>{name}</b> and setup a new parcel data
            source?
          </p>
        </ContentSection>
      </FormSection>
      <ButtonSection>
        <PrimaryButtons>
          <Button
            variant="secondary"
            onPress={onCancel}
            size="medium"
            title="Cancel"
          />
          <Button
            variant="critical"
            size="medium"
            onPress={() => {
              history.push(
                buildLink("parcelImportConfigCreate", {
                  importTaskType: importTaskType,
                }),
              );
            }}
            title="I understand, and want to update the parcel source"
          />
        </PrimaryButtons>
      </ButtonSection>
    </Container>
  );
};
